<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import ReportsRequest from './ReportsRequest';
import ReportTerminateVue from './components/ReportTerminate.vue';
import ReportStatusColumnVue from './components/ReportStatusColumn.vue';
import ReportTypeColumnVue from './components/ReportTypeColumn.vue';

export default {
  name: 'ReportsList',
  extends: CrudListVue,
  data: () => ({
    requestClass: ReportsRequest,
    hideEdit: true,
    hideDelete: true,
    headers: [
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Quantidade de registros',
        value: 'total',
      },
      {
        text: 'Situação',
        value: 'status',
        component: ReportStatusColumnVue,
      },
      {
        text: 'Tipo',
        value: 'type',
        component: ReportTypeColumnVue,
      },
      {
        text: 'Início geração',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Fim geração',
        value: 'updatedAt',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Detalhe',
        value: 'error',
      },
      {
        text: 'Ações',
        value: 'id',
        component: ReportTerminateVue,
      },
    ],
  }),
};
</script>
